import firebase from '../config/firebase.config';

const db = firebase.firestore();

export const APPLICATION_INFO_COLLECTION = 'applicationInfo';

/** Top-level docs merged for app name lookups (order only matters if keys overlap). */
export const APPLICATION_INFO_DOCUMENT_IDS = ['windows', 'mac', 'linux'];

/**
 * Merge top-level fields from document snapshots in order.
 * @param {firebase.firestore.DocumentSnapshot[]} snapshotsInOrder
 * @returns {Record<string, unknown>}
 */
export function mergeApplicationInfoDocumentSnapshots(snapshotsInOrder) {
  const merged = {};
  snapshotsInOrder.forEach((snap) => {
    if (!snap || !snap.exists) return;
    const docData = snap.data();
    if (docData && typeof docData === 'object') {
      Object.assign(merged, docData);
    }
  });
  return merged;
}

// Cached for the session — this data never changes at runtime.
// All callers share one promise; parallel mounts get the same in-flight request.
let _mappingPromise = null;

/**
 * Loads only `windows`, `mac`, and `linux` from `applicationInfo` (top-level fields only).
 * @returns {Promise<Record<string, unknown>>}
 */
export function fetchApplicationInfoMapping() {
  if (_mappingPromise) return _mappingPromise;
  _mappingPromise = (async () => {
    try {
      const col = db.collection(APPLICATION_INFO_COLLECTION);
      const snapshots = await Promise.all(
        APPLICATION_INFO_DOCUMENT_IDS.map((id) => col.doc(id).get())
      );
      return mergeApplicationInfoDocumentSnapshots(snapshots);
    } catch (error) {
      _mappingPromise = null; // allow retry on next call
      console.error('Error fetching application info:', error);
      return {};
    }
  })();
  return _mappingPromise;
}
